// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__gahNQ","heading":"Privacy_heading__UeK+W","privacybackground":"Privacy_privacybackground__nrO4j"};